import { render, staticRenderFns } from "./VInvoices.vue?vue&type=template&id=7ee24af7&"
import script from "./VInvoices.vue?vue&type=script&lang=js&"
export * from "./VInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports